<template>
  <div class="model-config">
    <div class="head">
      <img src="~_img/common/head-icon.png" alt="" />
      <span>模块配置管理</span>
    </div>
    <div class="content-wrap">
      <div class="warning">
        <img src="~_img/common/danger.png" alt="" />
        <div class="text">
          <div class="t1">
            1.模块配置：根据各项目实际情况，给各组织配置初始化功能模块，上级组织可在“角色权限管理”模块配置下级组织角色的功能权限。
          </div>
          <div class="t2">
            2.需先设置“组织树节点”，再进行“模块配置”！<span
              @click="$router.push({ path: $route.fullPath, query: { menu: 'organTree' } })"
              >组织树节点管理>></span
            >
          </div>
        </div>
      </div>
      <div class="switch">
        <el-switch @change="setModulePermission" v-model="switchForm.addGroupFlag" inactive-text="支持组织树新增组织">
        </el-switch>
        <el-switch @change="setModulePermission" v-model="switchForm.relationFlag" inactive-text="PC端与移动端权限关联">
        </el-switch>
      </div>
      <IviewTable :data="tableData" :columns="tableCol" :page="pager">
        <ul class="table-cao" slot="cao" slot-scope="{ row }">
          <li @click="openDialog(row)">配置模块</li>
        </ul>
      </IviewTable>
    </div>
    <AddConfig v-model="nodePopup" :data="currentTableData"></AddConfig>
  </div>
</template>
<script>
import AddConfig from './modules/addConfig.vue'
export default {
  name: 'moduleConfig',
  components: { AddConfig },
  data() {
    return {
      switchForm: {
        addGroupFlag: false,
        relationFlag: false
      },
      tableData: [],
      tableCol: [
        { title: '组织树节点', key: 'orgLevel', align: 'center' },
        { title: '节点别名', key: 'orgLevelName', align: 'center' },
        { title: '操作', slot: 'cao', align: 'center' }
      ],
      pager: {
        total: 0
      },
      nodePopup: false,
      currentTableData: {}
    }
  },
  created() {
    this.getList()
    this.getModulePermission()
  },
  methods: {
    getList() {
      this.$api.config.getNode().then((res) => {
        this.tableData = res.data
      })
    },
    openDialog(row) {
      this.nodePopup = true
      this.currentTableData.nodeName = row.orgLevelName
      this.currentTableData.orgLevel = row.orgLevel
    },
    getModulePermission() {
      this.$api.config.getNodePermission().then((res) => {
        this.switchForm = {
          addGroupFlag: Boolean(res.data.addGroupFlag),
          relationFlag: Boolean(res.data.relationFlag)
        }
      })
    },
    setModulePermission() {
      let params = {
        addGroupFlag: +this.switchForm.addGroupFlag,
        relationFlag: +this.switchForm.relationFlag
      }
      this.$api.config
        .putNodePermission(params)
        .then((res) => {
          this.$Message.success('操作成功')
        })
        .catch((err) => {
          this.getModelPermission()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.model-config {
  background: #f2f3f4;
  padding: 0 !important;
  .head {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px;
    img {
      width: 18px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2c3542;
      margin-left: 8px;
    }
  }
  .content-wrap {
    padding: 20px;
    margin-top: 20px;
    background: #fff;
    .warning {
      display: flex;
      background: #f3e9e9;
      border-radius: 4px;
      padding: 10px 14px;
      img {
        width: 19px;
        height: 19px;
        margin-top: 6px;
      }
      .text {
        flex: 1;
        margin-left: 10px;
        .t1,
        .t2 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #be5a57;
          margin: 4px 0;
        }
        .t2 span {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2c46b5;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
  .switch {
    margin: 24px 0 16px;
    .el-switch {
      margin-right: 80px;
    }
  }
  /deep/.i-table {
    .ivu-table-wrapper {
      height: calc(100vh - 380px);
    }
    .i-page {
      bottom: -44px;
      display: none;
    }
  }
}
</style>
